export default __webpack_public_path__ + "static/media/1428.55842cc8.png";